import React from "react";
import Icon from "@ant-design/icons";

const LightModeSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99998 15.6164C13.1019 15.6164 15.6164 13.1019 15.6164 9.99998C15.6164 6.89811 13.1019 4.38354 9.99998 4.38354C6.89811 4.38354 4.38354 6.89811 4.38354 9.99998C4.38354 13.1019 6.89811 15.6164 9.99998 15.6164Z"
      fill="currentColor"
    />
    <path
      d="M9.60048 3.72146H10.3996C10.6518 3.72146 10.8562 3.51703 10.8562 3.26484V0.456621C10.8562 0.204429 10.6518 0 10.3996 0H9.60048C9.34829 0 9.14386 0.204429 9.14386 0.456621V3.26484C9.14386 3.51703 9.34829 3.72146 9.60048 3.72146Z"
      fill="currentColor"
    />
    <path
      d="M16.2786 9.60048V10.3996C16.2786 10.6518 16.483 10.8562 16.7352 10.8562H19.5434C19.7956 10.8562 20 10.6518 20 10.3996V9.60048C20 9.34829 19.7956 9.14386 19.5434 9.14386H16.7352C16.483 9.14386 16.2786 9.34829 16.2786 9.60048Z"
      fill="currentColor"
    />
    <path
      d="M10.3996 20C10.6518 20 10.8562 19.7956 10.8562 19.5434V16.7352C10.8562 16.483 10.6518 16.2786 10.3996 16.2786H9.60048C9.34829 16.2786 9.14386 16.483 9.14386 16.7352V19.5434C9.14386 19.7956 9.34829 20 9.60048 20H10.3996Z"
      fill="currentColor"
    />
    <path
      d="M0.456621 10.8562H3.26484C3.51703 10.8562 3.72146 10.6518 3.72146 10.3996V9.60048C3.72146 9.34829 3.51703 9.14386 3.26484 9.14386H0.456621C0.204429 9.14386 0 9.34829 0 9.60048V10.3996C0 10.6518 0.204429 10.8562 0.456621 10.8562Z"
      fill="currentColor"
    />
    <path
      d="M14.7221 5.84295C14.9005 6.02126 15.1896 6.02129 15.3679 5.84295L17.3536 3.85724C17.5319 3.67889 17.5319 3.3898 17.3536 3.21149L16.7886 2.64645C16.6102 2.46811 16.3211 2.46811 16.1428 2.64645L14.1571 4.63215C13.9787 4.81046 13.9787 5.0996 14.1571 5.27791L14.7221 5.84295Z"
      fill="currentColor"
    />
    <path
      d="M16.7886 17.3536L17.3536 16.7885C17.5319 16.6102 17.5319 16.3211 17.3536 16.1428L15.3679 14.1571C15.1895 13.9787 14.9004 13.9787 14.7221 14.1571L14.1571 14.7221C13.9787 14.9004 13.9787 15.1896 14.1571 15.3679L16.1428 17.3536C16.3211 17.5319 16.6103 17.5319 16.7886 17.3536Z"
      fill="currentColor"
    />
    <path
      d="M3.85724 17.3536L5.84297 15.3679C6.02133 15.1895 6.02133 14.9004 5.84297 14.7221L5.27793 14.1571C5.0996 13.9787 4.81049 13.9787 4.63218 14.1571L2.64645 16.1428C2.46811 16.3211 2.46811 16.6102 2.64645 16.7885L3.21149 17.3536C3.3898 17.5319 3.67891 17.5319 3.85724 17.3536Z"
      fill="currentColor"
    />
    <path
      d="M4.63211 5.84295C4.81045 6.02129 5.09956 6.02126 5.27787 5.84295L5.84291 5.27791C6.02127 5.0996 6.02127 4.81046 5.84291 4.63215L3.85718 2.64645C3.67885 2.46811 3.38974 2.46811 3.21143 2.64645L2.64638 3.21149C2.46805 3.3898 2.46805 3.67893 2.64638 3.85724L4.63211 5.84295Z"
      fill="currentColor"
    />
  </svg>
);

const LightModeIcon = (props) => <Icon component={LightModeSvg} {...props} />;

export default LightModeIcon;
